import { render, staticRenderFns } from "./AuthorizeSelling.vue?vue&type=template&id=dd8504b6&scoped=true"
import script from "./AuthorizeSelling.vue?vue&type=script&lang=js"
export * from "./AuthorizeSelling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd8504b6",
  null
  
)

export default component.exports